import logo from './logo.svg';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lime,green, purple,cyan,teal,grey,blue } from '@mui/material/colors';
import Main from './layouts/Main';
import Home from './views/Home';
import Privacy from './views/Privacy.';
import Terms from './views/Terms';
import DeleteAccount from './views/DeleteAccount';
import HelpCenter from './views/HelpCenter';
import AboutUs from './views/AboutUs';
import Highlights from './views/Highlights';
import ContactUs from './views/ContactUs';

const defaultTheme = createTheme({

  components: {
    MuiButton:{
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: "#292929",
            borderRadius:8,
            color:"white"
          },
        },
        {
          props: { variant: 'contained-primary' },
          style: {
            backgroundColor: "#FFAB00",
            borderRadius:16
          },
        },

        {
          props: { variant: 'outlined' },
          style: {
            borderRadius:16
          }
        },
        
      ]
    },

    MuiContainer: {
      variants: [
        {
          props: { variant: 'default' },
          style: {
            backgroundColor: "#FFF",
          },
        },
      ]
    },

    MuiCard: {
      styleOverrides: {
        root: { 
        },
      },

      variants:[
        {
          props:{variant:"soft"},
          style:{
            boxShadow: "0 10px 10px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)",
          }
        },
        {
          props:{variant:"zoom"},
          style:{
            boxShadow: "0 10px 10px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)",
            borderRadius: 8,
            zIndex:0,
            position: "relative",
            transition: "transform 0.15s ease-in-out",
            "&:hover": { transform: "scale3d(1.05, 1.05, 1)" },
          }
        },
        {
          props:{variant:"square"},
          style:{
            borderRadius: 0,
          }
        },

        {
          props:{variant:"cartoon"},
          style:{
            borderRadius: 0,
            backgroundColor:"#fafafa"
          }
        }
      ]
    },

    MuiAppBar:{
      variants:[
        {
          props: { variant: 'soft-shadow' },
          style: {
            boxShadow: "0 20px 20px 0 rgba(0, 0, 0, 0.1), 0 6px 40px 0 rgba(0, 0, 0, 0.2)",
          },
        },

        {
          props: { variant: 'no-shadow' },
          style: {
            marginTop:8,
            boxShadow: "0 20px 20px 0 rgba(0, 0, 0, 0), 0 6px 40px 0 rgba(0, 0, 0, 0)",
          },
        },
      ]
    },

    MuiTypography:{
      variants:[
        {
          props: { variant: 'header' },
          style: {
            fontSize:27,
            color:"#808080",
            fontFamily: ["Poppins", "sans-serif"].join(","),
          },
        },
        {
          props: { variant: 'subtitle1' },
          style: {
            fontSize:16,
            fontWeight:"bolder",
            color:"#000",
            fontFamily: ["Poppins", "sans-serif"].join(","),
          },
        },
        {
          props: { variant: 'subtitle2' },
          style: {
            fontSize:16,
            fontWeight:"bolder",
            color:"#808080",
            fontFamily: ["Poppins", "sans-serif"].join(","),
          },
        },

        {
          props: { variant: 'h3' },
          style: {
            fontWeight:"bolder",
            fontFamily: ["Poppins", "sans-serif"].join(","),
          },
        },
        {
          props: { variant: 'h4' },
          style: {
            fontWeight:"bolder",
            fontFamily: ["Poppins", "sans-serif"].join(","),
          },
        },
        {
          props: { variant: 'h5' },
          style: {
            fontWeight: "bolder",
            fontFamily: ["Poppins", "sans-serif"].join(","),
          },
        },
      ]
    },

    MuiMenuItem: {
      variants:[
        {
          props: { variant: 'appbar' },
          style: {
            color:"#000",
            fontWeight:"bolder",
            fontFamily: ["Poppins", "sans-serif"].join(","),
          },
        },
      ]
    }
  },


  palette: {
    primary: {
      light: "#FFAB00",
      main: "#FFAB00",
      dark:  "#292929",
      contrastText: '#000',
    },
    secondary: {
        light: blue[600],
        main: teal[400],
        dark:  blue[400],
        contrastText: '#000',
    },
  },
});


function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main props={<Home></Home>}></Main>} />
        <Route path="/privacy" element={<Main props={<Privacy></Privacy>}></Main>} />
        <Route path="/terms" element={<Main props={<Terms></Terms>}></Main>} />
        <Route path="/delete-account" element={<Main props={<DeleteAccount></DeleteAccount>}></Main>} />
        <Route path="/help-center" element={<Main props={<HelpCenter></HelpCenter>}></Main>} />
        <Route path="/about-us" element={<Main props={<AboutUs></AboutUs>}></Main>}/>
        <Route path="/highlights" element={<Main props={<Highlights></Highlights>}></Main>}/>
        <Route path="/contact-us" element={<Main props={<ContactUs></ContactUs>}></Main>}/>
      </Routes>
    </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
